import { Fragment } from "react";
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from "@headlessui/react";
import { supabase } from "../../lib/supabase";
import * as Sentry from "@sentry/react";
import classNames from "classnames";
import { User01Icon, LogOut02Icon } from "@happy-doc/shared-icons";
/**
 * Profile menu component
 * @returns React.FC
 * @example <ProfileMenu />
 */
const ProfileMenu: React.FC = () => {

    /**
     * Sign out the user
     * @param {Event} e - The event object
     * @returns {Promise<void>}
     * */
    const signOut = async (e: { preventDefault: () => void }): Promise<void> => {
        try {
            e.preventDefault();
            const { error } = await supabase.auth.signOut({ scope: "local" });
            if (error) {
                Sentry.captureException(error);
                // Clearing specific local storage key based on a pattern. In case auth breaks down.
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key && key.match(/^sb-.*-auth-token$/)) {
                        localStorage.removeItem(key);
                    }
                }
                window.location.href = "/";
            } else {
                localStorage.clear();
                window.location.href = "/";
            }
        } catch (error) {
            Sentry.captureException(error);
        }
    };

    return (
        <Fragment>
            <Menu as="div" className="relative inline-block text-left">
                <div className="relative ">
                    <MenuButton className={"focused"}>
                        <div className={classNames("hover:cursor-pointer", "flex items-center justify-center p-2 bg-max-25 rounded-lg border border-solid border-gray-200 max-h-[36px] max-w-[36px] cursor-pointer relative  ")}>
                            <User01Icon className="w-5 h-5 text-color-600 bg-max-25" />
                        </div>
                    </MenuButton>
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                >
                    <MenuItems className="absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
                        <div className="px-1 py-1">
                            <MenuItem>
                                {({ focus }) => (
                                    <button
                                        onClick={signOut}
                                        className={`${focus ? 'bg-max-700 text-white' : 'text-gray-700'
                                            } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                                    >
                                        <LogOut02Icon className={`mr-2 h-4 w-4 ${focus ? 'text-white' : 'text-gray-700'}`} aria-hidden="true" />
                                        Sign Out
                                    </button>
                                )}
                            </MenuItem>
                        </div>
                    </MenuItems>
                </Transition>
            </Menu>
        </Fragment>
    );
};

export default ProfileMenu;